export enum Fields {
  SEGMENT = 'semgent_form',
  NAME = 'name',
  ROLE = 'minimumRoleValue',
  LABEL = 'label',
}
